import request from "@/utils/request";
import {dataFix} from "ali-oss/lib/common/utils/dataFix";

export function country() {
    return request({
        url: `api/comment/subsetCate/countryInformationList`,
        method: "get",
    })
}

export function city(id) {
    return request({
        url: `api/comment/subsetCate/getCountyList?id=${id || ''}`,
        method: "get",
    })
}

//产品类型
export function typeAll() {
    return request({
        url: `/api/equipmentType/typeAll`,
        method: 'get'
    })
}

// 查询列表
export function selectAll(data) {
    return request({
        url: `/api/equipment/selectAll`,
        method: 'get',
        params: data
    })
}

//新增
export function addEquipment(data) {
    return request({
        url: `/api/equipment/addEquipment`,
        method: 'post',
        data
    })
}

//查看
export function selectById(data) {
    return request({
        url: '/api/equipment/selectById',
        method: 'get',
        params: data
    })
}

// 编辑
export function updataEquipment(data) {
    return request({
        url: 'api/equipment/updateEquipment',
        method: 'put',
        data
    })
}

export function addEquipmentParmenter(data) {
    return request({
        url: `api/equipment/addEquipmentParmenter`,
        method: 'post',
        data
    })
}


//列表
export function selectByPage(data) {
    return request({
        url: `/api/equipment/selectByPage`,
        method: 'get',
        params: data
    })
}

//是否点赞
export function isLike(data) {
    return request({
        url: `/api/equipment/isLike`,
        method: 'get',
        params: data
    })
}

//点赞
export function like(data) {
    return request({
        url: `/api/equipment/like`,
        method: 'put',
        params: data
    })
}
